import { render } from "./manage-admin.vue?vue&type=template&id=75f70823"
import script from "./manage-admin.vue?vue&type=script&lang=js"
export * from "./manage-admin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__